export const SET_SELECTED_FLEET = (data) => {
  return {
    type: "SET_SELECTED_FLEET",
    payload: data,
  };
};

export const SET_SELECTED_DEVICE = (data) => {
  return {
    type: "SET_SELECTED_DEVICE",
    payload: data,
  };
};

export const SET_FLEET_DEVICES = (data) => {
  return {
    type: "SET_FLEET_DEVICES",
    payload: data,
  };
};

export const SET_QUERY_DEVICES = (data) => {
  return {
    type: "SET_QUERY_DEVICES",
    payload: data,
  };
};

export const SHOW_DIALOG = (data) => {
  return {
    type: "SHOW_DIALOG",
    payload: data,
  };
};

export const HIDE_DIALOG = () => {
  return {
    type: "HIDE_DIALOG",
  };
};
